import { Middleware } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const handleSetCredentials = (action: any) => {
  const {
    jwtToken,
    refreshToken,
    role,
    id,
    firstName,
    lastName,
    username,
    changePasswordOnLogin,
    isPasswordExpired,
  } = action.payload;
  if (jwtToken) {
    const tokenData = jwtDecode<any>(jwtToken); 
    const tokenValues = Object.fromEntries(
      Object.entries(tokenData).map(([key, value]) => {
        const shortKey = key.includes('/') ? key.split('/').pop() : key;
        return [shortKey, value];
      })
    );   
    localStorage.setItem("exp", tokenValues?.exp ? tokenValues.exp.toString() : "");
    localStorage.setItem("timestamp", tokenValues?.timezone ? tokenValues.timezone.toString() : "");
  }
  localStorage.setItem("jwtToken", jwtToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("roleId", role?.id ?? null);
  localStorage.setItem("roleName", role?.roleName ?? "");
  localStorage.setItem("isLoggedIn", jwtToken ? "true" : "false");
  localStorage.setItem("id", id);
  localStorage.setItem("firstName", firstName);
  localStorage.setItem("lastName", lastName);
  localStorage.setItem("username", username);
  localStorage.setItem("changePasswordOnLogin", changePasswordOnLogin);
  localStorage.setItem("isPasswordExpired", isPasswordExpired);
};

const handleResetAuthState = () => {
  const profileClientId = localStorage.getItem("profileClientId");
  const userName = localStorage.getItem("username");
  const rememberMe = localStorage.getItem("rememberMe");
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem("profileClientId", profileClientId ?? "");
  localStorage.setItem("username", userName ?? "");
  localStorage.setItem("rememberMe",rememberMe ?? "");
};

const handleSetUserId = (action: any) => {
  const { id } = action.payload;
  localStorage.setItem("id", id);
};

const handleResetUserId = () => {
  localStorage.removeItem("id");
};

const handleSetUserProfile = (action: any) => {
  const { phone } = action.payload;
  localStorage.setItem("phone", phone);
};

const actionHandlers: any = {
  "auth/setCredentials": handleSetCredentials,
  "auth/resetAuthState": handleResetAuthState,
  "auth/setUserId": handleSetUserId,
  "auth/resetUserId": handleResetUserId,
  "user/setUserProfile": handleSetUserProfile,
};

const storageMiddleware: Middleware = () => (next) => (action: any) => {
  const handler = actionHandlers[action?.type];
  if (handler) {
    handler(action);
  }
  return next(action);
};

export default storageMiddleware;
